import React from "react";
import PlanillaPageLayout from "./PlanillaPageLayout";
import PlanillaTabs from "./components/PlanillaTabs";

const RRHHImportarPlanilla = () => (
  <PlanillaPageLayout title="Planilla XLSM">
    <PlanillaTabs />
  </PlanillaPageLayout>
);

export default RRHHImportarPlanilla;
